var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseEvent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  viewBox: "0 0 100 100"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M50 98c26.51 0 48-21.49 48-48S76.51 2 50 2 2 23.49 2 50s21.49 48 48 48m0 2C22.386 100 0 77.614 0 50S22.386 0 50 0s50 22.386 50 50-22.386 50-50 50"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.121 63.464 74 65.586l-2.121-2.122a1 1 0 0 0-1.415 1.415L72.586 67l-2.122 2.121a1 1 0 1 0 1.415 1.415L74 68.414l2.121 2.122a1 1 0 1 0 1.415-1.415L75.414 67l2.122-2.121a1 1 0 0 0-1.415-1.415"
}), /*#__PURE__*/React.createElement("path", {
  d: "M74 76c-3.53 0-6.59-2.04-8.061-5a9.2 9.2 0 0 1-.719-2c-.14-.64-.22-1.31-.22-2 0-4.96 4.04-9 9-9 .689 0 1.36.08 2 .22 4 .92 7 4.51 7 8.78 0 4.96-4.04 9-9 9m-10.82-7H27c-.55 0-1-.45-1-1V30c0-.55.45-1 1-1h46c.55 0 1 .45 1 1v26c-6.08 0-11 4.92-11 11 0 .68.061 1.35.18 2M76 56.19V30c0-1.66-1.34-3-3-3H27c-1.66 0-3 1.34-3 3v38c0 1.66 1.34 3 3 3h36.75c1.6 4.1 5.58 7 10.25 7 6.07 0 11-4.92 11-11 0-5.39-3.88-9.87-9-10.81"
}), /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 2,
  x: 36,
  y: 51,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 40h51v2H24z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 19,
  height: 2,
  x: 36,
  y: 58,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 36,
  y: 23,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 10,
  x: 62,
  y: 23,
  rx: 1
}))));
export default SvgCloseEvent;